/**
 * PhotoUploader — 사용자PC(/u/orders) 오더 작업사진/작업문서 업로드·뷰어.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 전역함수 photoUpload / uploadStart / updateWorksPhoto /
 * upload_pc_done / photozoom (+ PicWin 상태변수) 를 이 클래스로 캡슐화했다.
 *
 * 외부(레거시)에서 호출되는 진입점은 $j.Pages.Desktop.Orders.initialize() 가 window 로 브리지한다:
 *   - window.photoUpload(n, orderno)  : desktop/tax/bizform_otherform.inc.php (작업문서/현장사진 추가)
 *   - window.uploadStart()            : orders.blade.php <input type=file onchange>
 *   - window.photozoom(n)             : upload_pc_done 이 만든 썸네일 onclick + bizform_otherform.inc.php
 *
 * 의존
 * ────
 * - DOM: form[name=uploadForm] (#file, hidden ordernum/type), #upop_onlyphotoDiv (썸네일 컨테이너)
 * - 전역: window.orderTax(current_ordernum), window.tsalert, jQuery($)
 * - 서버: POST /api/upload → POST /u/ajax/order/{n}/photos → GET /u/ajax/order/{n}/work-photos
 */
export default class PhotoUploader {
    constructor() {
        // 사진 팝업창(window.open) 핸들과 마지막 위치. photozoom 재호출 시 위치 유지.
        this._picWin = null;
        this._picWinPosX = 0;
        this._picWinPosY = 0;
    }

    /**
     * 파일 선택창 트리거. (bizform 팝업의 '작업문서추가'(n=1) / '현장사진추가'(n=2))
     * @param {number} n       1=작업문서(docs), 2=현장사진(works)
     * @param {number} orderno 오더번호
     */
    trigger = (n, orderno) => {
        document.uploadForm.ordernum.value = orderno;
        document.uploadForm.type.value = (n == 2 ? "works" : "docs");
        document.getElementById("file").click();
    }

    /** <input type=file> onchange → 파일 업로드 시작 (/api/upload) */
    uploadStart = () => {
        if (document.getElementById("file").value.length < 5) return;
        const dtype = document.uploadForm.type.value;
        let tag = 'diary2'; if (dtype == 'works') tag = 'diary1'; // diary1(현장사진), diary2(작업문서)
        const m = document.uploadForm;
        let fd = new FormData(m);
        fd.append('tag', tag);
        fd.append('id', document.uploadForm.ordernum.value);
        $.ajax({
            type: 'POST',
            url: `/api/upload`,
            data: fd,
            processData: false,
            contentType: false,
            success: (file) => {
                if (!file.id) {
                    $j.F.Admin.Util.tsalert('warning', '업로드에 실패하였습니다.');
                    return;
                }
                this._savePhoto(file);
            }
        });
    }

    /**
     * 업로드된 파일을 오더에 연결한다. (POST /u/ajax/order/{n}/photos)
     * @param file {id,host,path, file_date, file_gps, gpsaddress}
     */
    _savePhoto = (file) => {
        const ordernum = document.uploadForm.ordernum.value;
        const data = {
            type: document.uploadForm.type.value,
            files: (Array.isArray(file) ? file : [file]),
        };
        $.ajax({
            type: 'POST',
            url: `/u/ajax/order/${ordernum}/photos`,
            data,
            success: (r) => {
                if (r.result != true) {
                    $j.F.Admin.Util.tsalert('warning', '처리중 오류가 발생하였습니다.');
                    return;
                }
                this._reloadThumbs(ordernum);
            }
        });
    }

    /** 업로드 완료 후 썸네일 목록 갱신. (GET /u/ajax/order/{n}/work-photos) */
    _reloadThumbs = (orderNum) => {
        // 레거시 user_2000_ajax._money.php workUploaddoget → /u/ajax/order/{n}/work-photos (JSON)
        $.ajax({
            type: "GET", url: "/u/ajax/order/" + orderNum + "/work-photos", dataType: "json",
            success: (data) => {
                var obj = document.getElementById("upop_onlyphotoDiv");
                if (!obj) return;
                var esc = function (v) { return String(v == null ? "" : v).replace(/&/g, "&amp;").replace(/"/g, "&quot;"); };
                var h = "";
                (data.photos || []).forEach(function (p) {
                    var infos = p.num + "'" + p.gps + "'" + p.address + "'" + p.date;
                    h += "<div class='photoDiv'><img src='" + esc(p.thumbUrl) + "' class='wphotoimg' onclick=\"photozoom(" + p.num + ")\" orgin='" + esc(p.origin) + "' infos=\"" + esc(infos) + "\"></div>";
                });
                obj.innerHTML = h;
            }
        });
    }

    /**
     * 오더 관련 사진 뷰어 팝업 오픈.
     * @param n 작업사진 테이블 번호
     */
    zoom = (n) => {
        var obj = document.getElementById("upop_onlyphotoDiv");
        var inputs = obj.getElementsByTagName("IMG");
        var fns = "";
        var fnInfos = "";
        for (var i = 0; i < inputs.length; i++) {
            var orgin = inputs[i].getAttribute("orgin");
            var eainfo = inputs[i].getAttribute("infos");
            if (orgin == undefined) orgin = ""; if (orgin == null) orgin = "";
            if (eainfo == undefined) eainfo = ""; if (eainfo == null) eainfo = "";
            if (orgin.length > 10) {
                fns += orgin + "|";
                fnInfos += eainfo + "|";
            }
        }

        if (this._picWin != null && typeof (this._picWin) != 'undefined') {
            if (!this._picWin.closed) {
                if (this._picWin.screenX) {
                    this._picWinPosX = this._picWin.screenX;
                    this._picWinPosY = this._picWin.screenY;
                }
            }
        }
        var adr = "/order/photos?ordernum=" + window.orderTax.current_ordernum + "&n=" + n;
        var hh = 900;
        this._picWin = window.open(adr, 'photoPopupDetail', 'toolbar=no,status=no,WIDTH=500,HEIGHT=' + hh + ', directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no');
        this._picWin.moveTo(this._picWinPosX, this._picWinPosY);
        this._picWin.focus();
    }
}
